import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "../../../assets/style/featuresStyle/button.scss";
import { IconPlusQuestion } from "../../../assets/icon";
const ButtonSelectQuestion = ({
  handleClick,
  styleBtn,
  width,
  typeBtn,
  content,
  icon,
  disabled,
  backgroundColor,
}) => {
  const { t } = useTranslation();
  const style = {
    width,
    ...styleBtn,
    background: backgroundColor,
  };
  return (
    <Button
      disabled={disabled}
      shape="round"
      className={`btnSelectQuestion ${typeBtn} ${
        disabled ? "btnDisabled" : null
      }`}
      onClick={handleClick}
      style={style}
    >
      <span className="iconPlus">{icon ? icon : <IconPlusQuestion />}</span>
      {typeof content === "string" ? t(content) : content}
    </Button>
  );
};

export default ButtonSelectQuestion;
